import { create } from "mobx-persist";

const hydrate = create({
    storage: localStorage,
    jsonify: true
});

export default hydrate;